import AssetLoader from 'root/lib/AssetLoader';
import gameIds from '../../data/GameIds';
import {
  workshopMusic,
  workshopSfx,
} from './audio/audioMapAws';

class Loader extends AssetLoader {
  constructor() {
    super();
    this.gameId = gameIds.METAGAME;
    this.loaders = [];
  }

  loadCommonSfx = (callback) => {
    this.preLoadAwsAssets(
      [
        {
          ...workshopSfx,
          ...workshopMusic,
        },
      ],
      callback,
    );
  };
}

const instance = new Loader();
Object.freeze(instance);
export default instance;
